import styled, { css } from 'styled-components';
/**
 * PanelSticker Container
 */
export const panelStickerContainerStyles = () => css `
	position: relative;
`;
export const PanelStickerContainer = styled.div `
	${panelStickerContainerStyles}
`;
//# sourceMappingURL=panel-sticker.styled.js.map